import { render, staticRenderFns } from "./PermissionCell.vue?vue&type=template&id=52d25e32&scoped=true"
import script from "./PermissionCell.vue?vue&type=script&lang=js"
export * from "./PermissionCell.vue?vue&type=script&lang=js"
import style0 from "./PermissionCell.vue?vue&type=style&index=0&id=52d25e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d25e32",
  null
  
)

export default component.exports